import { MatchDetailContent } from "../../components/organisms/MatchDetailContentsList";
import { request } from "../../lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  ACCEPT_MATCH_TRANSPORTATIONS,
  STANDBY_TRANSPORTATIONS,
} from "../../common/query-keys";
import { MoreDetailTemplates } from "../../components/template/MoreDetailTemplates";
import { useState } from "react";
import TransferDetailModal from "../../components/molcules/Modal/TransferDetailModal/TransferDetailModal";
import { OrderType } from "../../interface/transportation";
import { useLocation, useNavigate } from "react-router";

const MatchListDetailPage = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const location = useLocation();
  /** ============================= state 영역 ============================= */

  const [isModal, setIsModal] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string>("운송 수락 실패");
  // 운송 리스트로 부터 선택해서 넘어온 아이템의 props 받기
  const detailData = location.state.item;

  /** ============================= API 영역 ============================= */

  /** 운송 수락 api 함수  */
  const { mutateAsync: postTransportationId } = useMutation({
    mutationFn: (data: OrderType) => {
      return request({
        method: "POST",
        url: `${ACCEPT_MATCH_TRANSPORTATIONS}/${data.order_number}`,
      });
    },
    onError: (e) => {
      setIsModal(true);
    },
    onSuccess: (res: any) => {
      console.log("운송 수락 성공", res);
      if (res.success) {
        navigate("/task-chargeTransfer");
      } else {
        setModalMessage(res.message);
        setIsModal(true);
      }
      queryClient.invalidateQueries({ queryKey: [STANDBY_TRANSPORTATIONS] });
    },
  });

  /** ============================= 비즈니스 로직 영역 ============================= */
  /** 운송수락 이벤트 핸들러 */
  const onSubmit = async (data: OrderType) => {
    try {
      await postTransportationId(data);
    } catch (error) {
      console.error("운송 수락 에러:", error);
    }
  };

  const handleModalClose = () => {
    setIsModal(false);
    navigate("/matchlist");
  };

  /** ============================= 컴포넌트 영역 ============================= */
  return (
    <>
      <MoreDetailTemplates pageTitle="운송매칭 내역 상세">
        <MatchDetailContent detailData={detailData} onSubmit={onSubmit} />
      </MoreDetailTemplates>
      {isModal && (
        <TransferDetailModal
          onClose={handleModalClose}
          modalMessage={modalMessage}
        />
      )}
    </>
  );
};
export default MatchListDetailPage;
